module.exports = __webpack_public_path__ + "2e6494748fe0bf28221a81292c659a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/ProductionShiftReportSection8.png
// module id = 319
// module chunks = 0